import {makeStyles} from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  container: {
    marginTop: 15,
  },
  title: {
    [theme.breakpoints.down('xs')]: {
      padding: '0 0 8px 0',
    },
  },
  items: {
    padding: '24px 5px',

    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  item: {
    marginTop: 0,
    padding: '0 5px',
    textAlign: 'left' as const,
    display: 'inline-block',
    verticalAlign: 'middle',

    [theme.breakpoints.down('xs')]: {
      '&:nth-child(even)': {
        textAlign: 'right' as const
      }
    },
  },
  value: {
    marginTop:  5,
    display: 'block',
    fontSize: 25,
    fontWeight: 300,

    [theme.breakpoints.down('xs')]: {
      marginTop: 2,
      fontSize: 18,
    },
  },
}))
